import { render, staticRenderFns } from "./ChargingRecordItem.vue?vue&type=template&id=2268c3fc&scoped=true"
import script from "./ChargingRecordItem.vue?vue&type=script&lang=js"
export * from "./ChargingRecordItem.vue?vue&type=script&lang=js"
import style0 from "./ChargingRecordItem.vue?vue&type=style&index=0&id=2268c3fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268c3fc",
  null
  
)

export default component.exports